///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';
import { GtthHistoryService } from '../../logical-topology/engine/history-service';
import { GtthNotificationsService } from '../../logical-topology/engine/notifications-service';
import { GtthExportService } from '../../../services/project/export.service';
import { GtthBomReportService } from '../../project-windows/bom_report/bom-report.service';
import { GtthProjectStateService } from '../../logical-topology/engine/project-state.service';

@Component({
    selector: 'winde-step-bom',
    templateUrl: './step-bom.component.html',
    styles: [
        `
            .btn-link {
                display: flex;
                align-items: center;
                text-align: left;
                font-weight: 350;
                padding: 3px 0;
                line-height: 1.15;
            }
        `
    ],
    styleUrls: ['../steps-toolbar.scss'],
    standalone: false
})
export class GtthStepBOMComponent {
    constructor(
        public readonly historyService: GtthHistoryService,
        private readonly notificationService: GtthNotificationsService,
        private readonly exportService: GtthExportService,
        private readonly bomService: GtthBomReportService,
        public readonly projectStateService: GtthProjectStateService
    ) {}

    exportLinkConfig(): void {
        this.exportService.exportLinkConfiguration(
            this.historyService.logicalTopology.exportLinksConfig,
            this.historyService.projectInfoViewService.activeLayer
        );
    }

    async exportRunnerJson(): Promise<void> {
        await this.bomService.saveBom(true);
        this.exportService.exportRunnerJsonConfiguration();
    }

    exportLinkSummary() {
        if (this.historyService.logicalTopology.isTopologyEmpty()) {
            this.notificationService.showError('Could not export empty topology');
        } else {
            this.exportService.exportLinkSummary(this.historyService.logicalTopology.exportLinksConfig);
        }
    }

    exportKmlFile() {
        if (this.historyService.logicalTopology.isTopologyEmpty()) {
            this.notificationService.showError('Could not export empty topology');
        } else {
            this.exportService.exportKmlFile();
        }
    }
}
